import { ISSUE_STATUSES } from "@miplatform/constants";
import { MiTHEME } from "@miplatform/theme";

export const TEMPLATE_WIDTH = 600;

export const SPECIFIED_TIME = "Specified Time";

export const ISSUE_STATUSES_COLOR_MAP = {
  [ISSUE_STATUSES.CLOSED]: {
    background: MiTHEME.palette.success.accent,
    border: MiTHEME.palette.success.main,
  },
  [ISSUE_STATUSES.CANCELLED]: {
    background: MiTHEME.palette.grey.medium,
    border: MiTHEME.palette.grey.main,
  },
  default: {
    background: MiTHEME.palette.error.accent,
    border: MiTHEME.palette.error.main,
  },
};
